/* ───────────────────  src/components/common/header/Head.jsx  ─────────────────── */
"use client";

import { useState, useRef, useEffect } from "react";
import "./head.css";
import { UserIcon } from "lucide-react";
import LoginSignupModal from "../../login/login.jsx";
import { useAuth } from "../../../contexts";            // ← unified barrel import

const Head = () => {
  /* ───────── Auth context ───────── */
  const { user, logout } = useAuth();      // login / signup not needed here
  const isLoggedIn = !!user;

  /* ───────── Local UI state ───────── */
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);

  /* pop-up modals */
  const [isLoginOpen,        setIsLoginOpen]        = useState(false);
  const [isSignupOpen,       setIsSignupOpen]       = useState(false);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);

  /* refs for outside-clicks */
  const navRef          = useRef(null);
  const userDropdownRef = useRef(null);

  /* active nav dropdowns (unchanged) */
  const [activeDropdown,     setActiveDropdown]     = useState(null);
  const [activeSubDropdown,  setActiveSubDropdown]  = useState(null);

  /* ───────── Click-outside handler ───────── */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setActiveDropdown(null);
        setActiveSubDropdown(null);
      }
      if (userDropdownRef.current && !userDropdownRef.current.contains(e.target)) {
        setUserDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* ───────── Modal helpers ───────── */
  const openLogin          = () => setIsLoginOpen(true);
  const closeLogin         = () => setIsLoginOpen(false);
  const openSignup         = () => setIsSignupOpen(true);
  const closeSignup        = () => setIsSignupOpen(false);
  const openForgotPassword = () => setIsForgotPasswordOpen(true);
  const closeForgotPassword= () => setIsForgotPasswordOpen(false);

  /* close dropdown when auth state changes (e.g., after login) */
  useEffect(() => {
    setUserDropdownOpen(false);
  }, [isLoggedIn]);

  /* ───────── Render ───────── */
  return (
    <>
      <section className="head">
        <div className="container flexSB headcontainer" ref={navRef}>
          {/* ─── Logo ─── */}
          <div className="logo">
            <img
              src="/logo.svg"
              alt="WELSHEDU Logo"
              className="logo_heading"
              height="90"
              width="100%"
            />
          </div>

          {/* ─── Social + user menu ─── */}
          <div className="social-login-container">
            <div className="social">
              <i className="fab fa-facebook-f icon"></i>
              <i className="fab fa-instagram icon"></i>
              <i className="fab fa-twitter icon"></i>
              <i className="fab fa-youtube icon"></i>
            </div>

            <div className="user-dropdown-container" ref={userDropdownRef}>
              <button
                className="user-avatar-button"
                onClick={() => setUserDropdownOpen(!userDropdownOpen)}
                aria-label="User menu"
              >
              
               
                  <UserIcon className="user-icon" />
                
              </button>

              {userDropdownOpen && (
                <div className="user-dropdown">
                  <div className="user-dropdown-header">
                    {isLoggedIn ? (
                      <p className="user-dropdown-subtitle">
                        Welcome back,&nbsp;
                        <strong>{user.name || user.email}</strong>
                      </p>
                    ) : (
                      <p className="user-dropdown-subtitle">
                        Log in or sign up for more explore
                      </p>
                    )}
                  </div>

                  {/* ─── Dropdown content ─── */}
                  {isLoggedIn ? (
                    <div className="user-dropdown-content">
                      <span className="dropdown-user-info" >
                        {/* {user.name && <strong>{user.name}</strong>} */}
                        {/* {user.name && user.email && " • "} */}
                        {user.email}
                      </span>

                      <a href="#" className="dropdown-link" onClick={() => setUserDropdownOpen(false)}>
                        My Courses
                      </a>
                      <a href="#" className="dropdown-link" onClick={() => setUserDropdownOpen(false)}>
                        Edit Profile
                      </a>

                      <button className="logout-button" onClick={logout}>
                        Log out
                      </button>
                    </div>
                  ) : (
                    <div className="user-dropdown-content">
                      <div className="auth-buttons">
                        <button
                          className="login-button"
                          onClick={() => {
                            setUserDropdownOpen(false);
                            openLogin();
                          }}
                        >
                          Log in
                        </button>
                        <button
                          className="signup-button"
                          onClick={() => {
                            setUserDropdownOpen(false);
                            openSignup();
                          }}
                        >
                          Sign up
                        </button>
                      </div>
                    </div>
                  )}

                  <div className="user-dropdown-footer">
                    <a
                      href="#"
                      className="privacy-link"
                      onClick={() => setUserDropdownOpen(false)}
                    >
                      Privacy &amp; Terms
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ─── Auth Modals ─── */}
      <LoginSignupModal
        isLoginOpen={isLoginOpen}
        isSignupOpen={isSignupOpen}
        isForgotPasswordOpen={isForgotPasswordOpen}
        onCloseLogin={closeLogin}
        onCloseSignup={closeSignup}
        onCloseForgotPassword={closeForgotPassword}
        onOpenLogin={openLogin}
        onOpenSignup={openSignup}
        onOpenForgotPassword={openForgotPassword}
        /* onLoginSuccess not needed – Head updates via context */
      />
    </>
  );
};

export default Head;

/* ──────────────────────────────  End of file  ────────────────────────────── */
